import { AsyncPipe } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs';

@Component({
  selector: 'app-filter-text',
  templateUrl: './filter-text.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterTextComponent),
      multi: true,
    },
  ],
  imports: [MatFormFieldModule, TranslateModule, ReactiveFormsModule, AsyncPipe, MatInputModule, MatIcon],
})
export class FilterTextComponent implements ControlValueAccessor {
  @Input() public label = '';
  @Input() public filterPlaceholder = 'global.filter.searchPlaceholder';

  public filterControl = new FormControl();
  public value: string | null = null;
  public showClearButton$ = this.filterControl.valueChanges.pipe(
    map((value) => {
      return value?.length;
    })
  );

  public onInput(): void {
    this.onChange(this.filterControl.value);
  }

  public clearInput(event: MouseEvent): void {
    event.stopPropagation();
    this.writeValue(null);
    this.onChange(null);
    this.filterControl.setValue(null);
  }

  public writeValue(value: string | null): void {
    this.value = value;
    this.filterControl.setValue(value, { emitEvent: false });
    this.filterControl.updateValueAndValidity({ emitEvent: true });
  }

  public registerOnChange(onChange: (value: string | null) => void): void {
    this.onChange = onChange;
  }

  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  public onChange = (value: string | null): void => {
    //placeholder implementation
    console.log(`Value changed ${value}`);
  };

  public onTouched = (): void => {
    //placeholder implementation
    console.log(`Form control ${FilterTextComponent.name} touched`);
  };
}
